module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/cobrand-topcashback-promo-7ef7dabf7363f6db117e2c0021a467d6.jpg";